import React, { useMemo, useRef, useState } from 'react';
import ModelCard from '../../ModelCard';
import { modalType, modelTypeMap } from '../../../../constants';
import CardShimmer from '../../CardShimmer';
import ScrollListener from '../../ScrollListener';
import LoadMore from '../../../base/LoadMore';
import { setModelsModalState, useModelsModalState } from '../../../../store/state';
import { pageSize, useCateListFetch } from './fetchHander';
import { v4 } from 'uuid';
import { EmptyState } from '../../../base/modelLib/EmptyState';
import { applyModel } from '../../../../helpers';
import { Divider } from '@mantine/core';
import { translate } from '@shakkerai/util-i18n';
import FlowCard from '../../FlowCard';
import { useAsyncEffect } from 'ahooks';
import { getCollectData } from '../../fetchList';

const SearchWrapper = (props) => {
  const { cols, modelType, ratio, menus, menuPath, setMenus } = props;
  const { loading, fetchList, list, setList, hasMore, setHasMore } = useCateListFetch(
    menuPath,
    modelType,
    setMenus,
    menus,
  );
  const keyword = useModelsModalState('keyword');
  const onlySeeStoreModel = useModelsModalState('onlySeeStoreModel');
  const collectModels = useModelsModalState('collectModels');
  const collectType = useModelsModalState('collectType');
  const [loadmore, setLoadMore] = useState(false);
  const turnPageErrorFlag = useRef(null); // 接口异常兜底

  const onModelScroll = async () => {
    const noMoreData = list?.list.length >= list?.total; // 测试数据异常兜底
    if (noMoreData) {
      setHasMore(false);
    }
    if (loading || loadmore || noMoreData || turnPageErrorFlag.current) return;
    setLoadMore(true);
    const res = await fetchList({
      modelType: modelTypeMap[modelType],
      page: list.page + 1,
      pageSize: pageSize,
      requestId: list.requestId ?? v4(), // 复用requestId防重复
      query: keyword,
      tagCode: modelType === modalType.WORKFLOW ? '102008' : undefined, // 流的特殊参数
    });
    if (!res) {
      turnPageErrorFlag.current = true;
      setLoadMore(false);
      return;
    }
    setList({
      ...res,
      list: (list?.list ?? []).concat(res.list),
    });
    setLoadMore(false);
  };

  useAsyncEffect(async () => {
    if (onlySeeStoreModel && !collectModels[collectType]?.length) {
      const res = await getCollectData(modelType, collectType);
      setModelsModalState({
        collectModels: {
          ...collectModels,
          [collectType]: res,
        },
      });
    }
  }, [onlySeeStoreModel]);

  const crossData = useMemo(() => {
    if (onlySeeStoreModel) {
      if (!collectModels[collectType]?.length || !list?.list) {
        return [];
      }
      return list?.list.filter((list) =>
        collectModels[collectType].some((collect) => collect?.versionId === list?.versionId),
      );
    } else {
      return list?.list ?? [];
    }
  }, [list?.list, collectModels, onlySeeStoreModel, collectType]);

  if (loading) {
    return (
      <div className="flex flex-wrap">
        <CardShimmer ratio={ratio} cols={cols} />
      </div>
    );
  }

  if (!crossData.length) return <EmptyState />;
  return (
    <ScrollListener className="flex flex-wrap pl-4 !h-auto" onScroll={() => onModelScroll()}>
      {crossData.map((item, idx) => {
        return modelType === modalType.WORKFLOW ? (
          <FlowCard data={item} key={idx} ratio={ratio} cols={cols} showAuthorInfo={!onlySeeStoreModel} />
        ) : (
          <ModelCard
            data={item}
            key={idx}
            ratio={ratio}
            cols={cols}
            showTag={true}
            query={''}
            onClick={applyModel}
            showAuthorInfo={!onlySeeStoreModel}
          />
        );
      })}
      {loadmore && <LoadMore />}
      {!hasMore && (
        <div className="w-full">
          <Divider
            label={translate('history_bottom')}
            color="#EBEBEB"
            className="w-[40%] m-auto"
            styles={{ label: { fontSize: '12px', color: '#969696', lineHeight: '12px' } }}
          />
        </div>
      )}
    </ScrollListener>
  );
};

export default SearchWrapper;
